import type React from 'react'
import styled from 'styled-components'

import Button from '@/components/Button'

const Container = styled.div`
  display: grid;
  grid-template-columns: min-content min-content;
  gap: 20px;
  justify-content: center;
`

interface Props {
  onClickForgotPassword: () => void
  onClickLogin: () => void
}

const Login: React.FC<Props> = ({ onClickLogin, onClickForgotPassword }) => (
  <Container>
    <Button type="button" $alternate onClick={onClickForgotPassword}>
      Forgot Password?
    </Button>
    <Button type="button" onClick={onClickLogin}>
      Log In
    </Button>
  </Container>
)

export default Login
